"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoilProResultContainerComponent = CoilProResultContainerComponent;
const React = __importStar(require("react"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const Fragments = __importStar(require("@genesys/shared/lib/graphql-fragments"));
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const ResultDefinition = __importStar(require("./results-definition"));
const ResultPresenter = __importStar(require("../result-presenter"));
const query = (0, graphql_tag_1.default) `
  query CoilProDxTargetTemperature(
    $inputs: [FreonTargetTemperatureInputType!]!
  ) {
    user {
      coilProDxTargetTemperature(input: $inputs) {
        ...CompleteCoilProFreonTargetTemperatureResults
      }
    }
  }
  ${Fragments.completeCoilProFreonTargetTemperatureResults}
`;
function CoilProResultContainerComponent(props) {
    return (React.createElement(GraphQLQuery.QueryUserSimple, { query: query, variables: {
            inputs: props.inputs
        } }, ({ user: { coilProDxTargetTemperature } }) => {
        const airresultsProperties = ResultDefinition.resultsDefinition;
        const results = coilProDxTargetTemperature.map(r => ({
            result: ResultDefinition.makePvs(r),
            error: r.results.hasError ? r.results.errors : undefined
        }));
        return (React.createElement(ResultPresenter.CoilProResultPresenterContainer, { resultDefinitions: airresultsProperties, results: results }));
    }));
}
//# sourceMappingURL=container-component.js.map